import { render, staticRenderFns } from "./NewAccessKey.vue?vue&type=template&id=4be61d42&scoped=true"
import script from "./NewAccessKey.vue?vue&type=script&lang=js"
export * from "./NewAccessKey.vue?vue&type=script&lang=js"
import style0 from "./NewAccessKey.vue?vue&type=style&index=0&id=4be61d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be61d42",
  null
  
)

export default component.exports